import axios from 'axios'
import {
  SET_TOKEN,
  RESET_TOKEN,
  SET_USER_INFO,
  GET_USER_INFO,
  GET_WORKSPACES,
  SET_ACTIVE_WORKSPACE,
  SET_WORKSPACES,
  SET_USER_TYPE,
  SET_PROFILE_INFO,
  SET_SUBSCRIPTION,
  SET_NOTIFICATION_SIDEBAR_COUNT
} from './types'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import {
  getByIdFromArray,
  replaceByTargetFromArray,
  removeByIdFromArray,
  getQueryParam
} from 'helpers/dataHelpers'
import history from 'browserHistory'
import store from 'store'
import Config from 'config'

const { apiUrl } = Config.network
const publicUrls = ['/login', '/register', '/account-recovery', '/password-reset', '/activate-account']


export function resetAuthToken() {
  return function action(dispatch) {
    localStorage.removeItem('authToken')
    localStorage.removeItem('activeWorkspace')
    localStorage.removeItem('userType')
    dispatch({
      type: RESET_TOKEN
    })
    delete axios.defaults.headers.common.Authorization
    if (!publicUrls.includes(history.location.pathname)) {
      history.push('/login')
    }
  }
}

export function storeAuthToken(authToken, rememberAuthToken) {
  return function action(dispatch) {
    if (rememberAuthToken) {
      localStorage.setItem('authToken', authToken)
    }
    dispatch({
      type: SET_TOKEN,
      payload: {
        authToken
      }
    })
    if (authToken) {
      axios.defaults.headers.common.Authorization = 'Token '.concat(authToken)
    } else {
      delete axios.defaults.headers.common.Authorization
    }
  }
}

export function getUserInfo() {
  const { authToken, activeWorkspace, activeWorkspacePk } = store.getState().auth
  return function action(dispatch) {
    if (!authToken) {
      dispatch(resetAuthToken())
    } else {
      axios.defaults.headers.common.Authorization = 'Token '.concat(authToken)
    }
    const workspaceQueryParam = getQueryParam(history.location.search, 'workspace')
    if (workspaceQueryParam) {
      axios.defaults.headers.common.Workspace = workspaceQueryParam
      localStorage.setItem('activeWorkspace', workspaceQueryParam)
    } else if (activeWorkspacePk) {
      axios.defaults.headers.common.Workspace = activeWorkspacePk
    }
    dispatch({
      type: GET_USER_INFO,
      payload: {
        userInfoIsLoading: true
      }
    })
    dispatch({
      type: GET_WORKSPACES
    })
    let url = `${apiUrl}users/me/`
    axios.get(url).then((body) => {
      const { data } = body
      dispatch({
        type: SET_USER_INFO,
        payload: {
          userId: data.id,
          name: data.name,
          position: data.position,
          userType: data.workspaces ? data.workspaces[0].role : null,
          email: data.email,
          avatar: data.avatar,
          workspaces: data.workspaces,
          receive_legal_updates: data.receive_legal_updates,
          receive_requests: data.receive_requests,
        }
      })
      if (activeWorkspace && activeWorkspace.id !== data.workspaces[0].id) {
        if (activeWorkspace) {
          localStorage.setItem('userType', activeWorkspace.role)
          axios.defaults.headers.common.Workspace = activeWorkspace.id
        } else {
          delete axios.defaults.headers.common.Workspace
        }
        history.push('/')
      }
      const currentActiveWorkspace = getByIdFromArray(data.workspaces, localStorage.getItem('activeWorkspace'))
      if (currentActiveWorkspace) {
        dispatch({
          type: SET_ACTIVE_WORKSPACE,
          payload: {
            activeWorkspace: currentActiveWorkspace,
            canSeeAll: currentActiveWorkspace.can_see_all,
            canShareIn: currentActiveWorkspace.can_share_in,
            canShareOut: currentActiveWorkspace.can_share_out,
            notificationCount: currentActiveWorkspace.notification_count
          }
        })

          axios.defaults.headers.common.Workspace = currentActiveWorkspace.id
          localStorage.setItem('userType', currentActiveWorkspace.role)
        dispatch({
          type: SET_USER_TYPE,
          payload: {
            userType: currentActiveWorkspace.role
          }
        })
        localStorage.setItem('userType', currentActiveWorkspace.role)
      } else if (data.workspaces && data.workspaces.length > 0) {
        dispatch({
          type: SET_ACTIVE_WORKSPACE,
          payload: {
            activeWorkspace: data.workspaces[0],
            canSeeAll: data.workspaces[0].can_see_all,
            canShareIn: data.workspaces[0].can_share_in,
            canShareOut: data.workspaces[0].can_share_out,
            notificationCount: data.workspaces[0].notification_count
          }
        })
        if (data.workspaces[0]) {
          axios.defaults.headers.common.Workspace = data.workspaces[0].id
          localStorage.setItem('userType', data.workspaces[0].role)
        } else {
          delete axios.defaults.headers.common.Workspace
        }
        dispatch({
          type: SET_USER_TYPE,
          payload: {
            userType: data.workspaces[0].role
          }
        })
        localStorage.setItem('activeWorkspace', data.workspaces[0].id)
        localStorage.setItem('userType', data.workspaces[0].role)
      } else {
        delete axios.defaults.headers.common.Workspace
      }
      dispatch({
        type: GET_USER_INFO,
        payload: {
          userInfoIsLoading: false
        }
      })
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
        dispatch(setSnackbar(error.response.data.detail, 'error'))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }
}


export function setUserInfo(userInfo) {
  return function action(dispatch) {
    dispatch({
      type: SET_USER_INFO,
      payload: {
        userId: userInfo.id,
        name: userInfo.name,
        position: userInfo.position,
        userType: userInfo.user_type,
        email: userInfo.email,
        avatar: userInfo.avatar,
        workspaces: userInfo.workspaces,
        receive_legal_updates: userInfo.receive_legal_updates,
        receive_requests: userInfo.receive_requests,
      }
    })
    if (userInfo.workspaces && userInfo.workspaces.length > 0) {
      dispatch({
        type: SET_ACTIVE_WORKSPACE,
        payload: {
          activeWorkspace: userInfo.workspaces[0],
          canSeeAll: userInfo.workspaces[0].can_see_all,
          canShareIn: userInfo.workspaces[0].can_share_in,
          canShareOut: userInfo.workspaces[0].can_share_out,
          notificationCount: userInfo.workspaces[0].notification_count
        }
      })
      if (userInfo.workspaces[0]) {
        axios.defaults.headers.common.Workspace = userInfo.workspaces[0].id
        localStorage.setItem('userType', userInfo.workspaces[0].role)
        localStorage.setItem('activeWorkspace', userInfo.workspaces[0].id)
        dispatch({
          type: SET_USER_TYPE,
          payload: {
            userType: userInfo.workspaces[0].role
          }
        })
      } else {
        delete axios.defaults.headers.common.Workspace
      }
    }
  }
}


export function setActiveWorkspace(workspace) {
  return function action(dispatch) {
    const { activeWorkspace, notificationCount } = store.getState().auth
    if (activeWorkspace && activeWorkspace.id !== workspace.id) {
      history.push('/')
    }
    activeWorkspace.notification_count = notificationCount
    dispatch(updateWorkspaceByTarget(activeWorkspace))
    localStorage.setItem('activeWorkspace', workspace.id)
    if (workspace) {
      axios.defaults.headers.common.Workspace = workspace.id
      localStorage.setItem('userType', workspace.role)
      localStorage.setItem('activeWorkspace', workspace.id)
    } else {
      delete axios.defaults.headers.common.Workspace
    }
    dispatch({
      type: SET_ACTIVE_WORKSPACE,
      payload: {
        activeWorkspace: workspace,
        canSeeAll: workspace.can_see_all,
        canShareIn: workspace.can_share_in,
        canShareOut: workspace.can_share_out,
        notificationCount: workspace.notification_count
      }
    })
    dispatch({
      type: SET_USER_TYPE,
      payload: {
        userType: workspace.role
      }
    })
    localStorage.setItem('userType', workspace.role)
  }
}


export function setWorkspace(newWorkspace) {
  return function action(dispatch) {
    dispatch({
      type: GET_USER_INFO,
      payload: {
        userInfoIsLoading: true
      }
    })
    const workspace = {...newWorkspace}
    workspace.role = 'OWNER'
    const { workspaces } = store.getState().auth
    let currentWorkspaces = workspaces
    if (!currentWorkspaces) {
      currentWorkspaces = []
    }
    dispatch({
      type: SET_WORKSPACES,
      payload: {
        workspaces: [...currentWorkspaces, ...[workspace]]
      }
    })
    dispatch({
      type: SET_ACTIVE_WORKSPACE,
      payload: {
        activeWorkspace: workspace,
        canSeeAll: workspace.can_see_all,
        canShareIn: workspace.can_share_in,
        canShareOut: workspace.can_share_out,
        notificationCount: workspace.notification_count
      }
    })
    if (workspace) {
      axios.defaults.headers.common.Workspace = workspace.id
      localStorage.setItem('userType', workspace.role)
      localStorage.setItem('activeWorkspace', workspace.id)
    } else {
      delete axios.defaults.headers.common.Workspace
    }
    dispatch({
      type: SET_USER_TYPE,
      payload: {
        userType: workspace.role
      }
    })
    localStorage.setItem('userType', workspace.role)
  }
}


export function setUserType(userType) {
  return function action(dispatch) {
    dispatch({
      type: SET_USER_TYPE,
      payload: {
        userType: userType
      }
    })
  }
}

export function setProfileInfo(name, avatar) {
  return function action(dispatch) {
    dispatch({
      type: SET_PROFILE_INFO,
      payload: {
        name: name,
        avatar: avatar
      }
    })
  }
}

export function setSubscriptions(receive_legal_updates, receive_requests) {
  return function action(dispatch) {
    dispatch({
      type: SET_SUBSCRIPTION,
      payload: {
        receive_legal_updates: receive_legal_updates,
        receive_requests: receive_requests,
      }
    })
  }
}

export function updateWorkspaceByTarget(target) {
  return function action(dispatch) {
    const { activeWorkspace, workspaces } = store.getState().auth
    const currentWorkspaces = replaceByTargetFromArray(workspaces, target)
    dispatch({
      type: SET_WORKSPACES,
      payload: {
        workspaces: currentWorkspaces
      }
    })
    if (target && target.id === activeWorkspace.id) {
      dispatch({
        type: SET_ACTIVE_WORKSPACE,
        payload: {
          activeWorkspace: target,
          canSeeAll: target.can_see_all,
          canShareIn: target.can_share_in,
          canShareOut: target.can_share_out,
          notificationCount: target.notification_count
        }
      })
      if (target) {
        axios.defaults.headers.common.Workspace = target.id
        localStorage.setItem('userType', target.role)
        localStorage.setItem('activeWorkspace', target.id)
      } else {
        delete axios.defaults.headers.common.Workspace
      }
    }
  }
}

export function removeWorkspaceById(id) {
  return function action(dispatch) {
    const { activeWorkspace, workspaces } = store.getState().auth
    const currentWorkspaces = removeByIdFromArray(workspaces, id)
    dispatch({
      type: SET_WORKSPACES,
      payload: {
        workspaces: currentWorkspaces
      }
    })
    const target = currentWorkspaces[0]
    if (id === activeWorkspace.id && target) {
      dispatch(setActiveWorkspace(target))
    }
  }
}

export function setNotificationsNumber(number) {
  return function action(dispatch) {
    dispatch({
      type: SET_NOTIFICATION_SIDEBAR_COUNT,
      payload: {
        notificationCount: number
      }
    })
  }
}
